import * as React from 'react';
export const inviteSvg = React.forwardRef(function inviteSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.75.75a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5V.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.5 15h7a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-3a4 4 0 0 0-4 4 2 2 0 0 0 2 2ZM2 13a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 2.5 2.5 0 0 0-2.5-2.5h-3A2.5 2.5 0 0 0 2 13Zm7-7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
    }),
  );
});
inviteSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var invite = {
  category: 'icon',
  colorable: true,
  name: 'invite',
  svg: inviteSvg,
};
